// photomodal.js

// --- Hulplogica ---

/**
 * Bepaalt de vorige en volgende broer/zus van de geklikte afbeelding binnen de content-block.
 */
function getSiblings($img, $) {
    // Zoek alleen afbeeldingen met de data-photo-full attribuut binnen dezelfde content-block
    const $siblings = $('img[data-photo-full]', $img.parents('.content-block')).get();
    let $previousSibling = null;
    let $nextSibling = null;
    const currentIndex = $siblings.findIndex(el => el === $img[0]);

    if (currentIndex > 0) {
        $previousSibling = $siblings[currentIndex - 1];
    }
    if (currentIndex >= 0 && currentIndex < $siblings.length - 1) {
        $nextSibling = $siblings[currentIndex + 1];
    }

    return { $previousSibling: $($previousSibling), $nextSibling: $($nextSibling) };
}

/**
 * Genereert de volledige modale HTML-inhoud voor de nieuwe afbeelding.
 */
function buildModalContent($img, photoSrc, $) {
    const { $previousSibling, $nextSibling } = getSiblings($img, $);

    // De basis wrapper van de modal
    const $modal = $(`<div id="photo-modal" class="photo-modal"><img src="${photoSrc}"/></div>`);

    // Figcaption toevoegen
    const $figcaption = $img.siblings('figcaption');
    if ($figcaption.length > 0) {
        $modal.append(`<figcaption>${$figcaption.html()}</figcaption>`);
    }

    // Navigatieknoppen toevoegen
    if ($previousSibling.length) {
        // Gebruik de data-photo-full van de broer/zus als bron voor de volgende update
        const prevSrc = $previousSibling.data('photo-full') || $previousSibling.attr('src');
        $modal.append(`<button class="prevnext-btn prev-btn" data-src="${prevSrc}"><span>vorige</span></button>`);
    }
    if ($nextSibling.length) {
        const nextSrc = $nextSibling.data('photo-full') || $nextSibling.attr('src');
        $modal.append(`<button class="prevnext-btn next-btn" data-src="${nextSrc}"><span>volgende</span></button>`);
    }

    return $modal;
}


// --- Export Functies ---

export const photoModal = {
    init($) {
        $('img[data-photo-full]').each((_, el) => {
            this.applyPhotoModal($(el), $);
        });
    },

    /**
     * Past de click-handler toe op een individuele afbeelding om de modal te openen.
     */
    applyPhotoModal($img, $) {
        $img.addClass('photo-modal-available');

        $img.off('click').on('click', () => {
            let photoSrc = $img.data('photo-full') || $img.get(0).currentSrc;

            // Genereer de inhoud en de knoppen
            const $modalContent = buildModalContent($img, photoSrc, $);

            // Open Featherlight. De oude modal wordt verwijderd als deze bestaat (normaal gedrag).
            $.featherlight($modalContent, { otherClose: '.prevnext-btn' });

            // Bind de navigatielogica aan de knoppen NA het openen van de modal
            this.bindPrevNextButtons($);
        });
    },

    /**
     * Update de inhoud van de open Featherlight modal.
     */
    updatePhotoModal($targetImg, $) {
        if ($('#photo-modal').length === 0) return; // Geen modal, niets te updaten.

        let newPhotoSrc = $targetImg.data('photo-full') || $targetImg.attr('src');

        // Bouw de NIEUWE inhoud (alleen de elementen BINNEN de #photo-modal div)
        const $newModalContent = buildModalContent($targetImg, newPhotoSrc, $);

        // Vervang de OUDE #photo-modal inhoud door de NIEUWE #photo-modal inhoud
        // Dit is de fix: vervang de innerHTML ZONDER de Featherlight wrapper te sluiten.
        $('#photo-modal').html($newModalContent.html());

        // Herbind de knoppen, omdat de HTML net vervangen is.
        this.bindPrevNextButtons($);
    },

    /**
     * Zoek de doelafbeelding op basis van de SRC en update of open de modal.
     */
    initPhotoModalFromSrc(imgSrc, $) {
        // Zoek de meest relevante img-tag met de bron
        const $targetImg = $(`img[data-photo-full="${imgSrc}"], img[src="${imgSrc}"]`).first();
        if ($targetImg.length === 0) return;

        if ($('#photo-modal').length > 0) {
            // Modal is open, dus update soepel
            this.updatePhotoModal($targetImg, $);
        } else {
            // Modal is gesloten (initialisatie via URL of externe trigger), dus klik om te openen
            $targetImg[0].click();
        }
    },

    /**
     * Binds de navigatielogica aan de prev/next knoppen na elke update/opening.
     */
    bindPrevNextButtons($) {
        $('.prevnext-btn').off('click').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation(); // Voorkom dat Featherlight sluit

            const targetSrc = $(e.currentTarget).data('src');
            // Gebruik de bron om de daadwerkelijke img-tag in de DOM te vinden
            const $targetImg = $(`img[data-photo-full="${targetSrc}"], img[src="${targetSrc}"]`).first();

            if ($targetImg.length) {
                this.updatePhotoModal($targetImg, $);
            }
        });
    }
};

window.photoModal = photoModal;
